<template>
  <div
    class="feature-alert"
    :class="[isHidden ? 'd-none' : 'd-flex']"
    :style="{
      '--alert-bg-color': `var(--p-color-bg-surface-${variant})`,
      '--alert-bg-hover-color': `var(--p-color-bg-surface-${variant}-hover)`,
      '--alert-text-color': `var(--p-color-text-${variant})`,
    }"
  >
    <div
      v-if="['warning', 'info', 'success'].includes(variant) && !noIcon"
      class="flex-shrink-1 pr-2"
    >
      <p-icon>
        <PAlertTriangle v-if="variant === 'warning'" />
        <PInfo v-if="variant === 'info'" />
      </p-icon>
    </div>
    <div class="flex-grow-1 pr-2">
      <slot name="title">
        <div v-if="title">
          <p-text variant="headingSm" as="strong">
            {{ title }}
          </p-text>
        </div>
      </slot>

      <p-text variant="bodySm" class="text-middle">
        <slot />
      </p-text>
      <div v-if="cta" class="pt-2">
        <p-btn @click="$emit('cta')">{{ cta }}</p-btn>
      </div>
    </div>
    <div v-if="closable" class="flex-shrink-1">
      <p-btn
        @click="
          isHidden = true;
          $emit('hide');
          $emit('close');
        "
        size="slim"
        icon-only
        variant="Tertiary"
      >
        <template #icon>
          <p-icon
            @click.native="
              isHidden = true;
              $emit('hide');
            "
          >
            <PX />
          </p-icon>
        </template>
      </p-btn>
    </div>
  </div>
</template>

<script>
import PBtn from '@/components/polaris/PBtn';
import PIcon from '@/components/polaris/PIcon';
import { getPIconComponents } from '@/components/polaris/polarisUtils';
import PText from '@/components/polaris/PText';
export default {
  name: 'PAlert',
  components: {
    PText,
    PBtn,
    PIcon,
    ...getPIconComponents(['XSmall', 'AlertTriangle', 'X', 'Info']),
  },
  props: {
    title: { type: String },
    cta: { type: String },
    variant: { type: String, default: 'warning' },
    closable: { type: Boolean },
    noIcon: { type: Boolean },
  },
  data() {
    return {
      isHidden: false,
    };
  },
};
</script>

<style scoped lang="scss">
.feature-alert {
  background-color: var(--alert-bg-color);
  padding: 0.5rem var(--p-space-100) 0.5rem var(--p-space-200);
  border-radius: var(--p-border-radius-200);

  color: var(--alert-text-color);
  &:hover {
    background-color: var(--alert-bg-hover-color);
  }
}

.text-middle {
  vertical-align: middle;
}
</style>
